import { IWirtschaftsplanErstellung } from "./IWirtschaftsplanErstellung";


export class WirtschaftsplanErstellung implements IWirtschaftsplanErstellung {

   static default = {
      bezeichnungWIP: '',
      gremiumBezeichnung: '',
      plangebiet: 0,
      plangebietBezeichnung: '',
      verwaltungsbereich: 0,
      verwaltungsbereichBezeichnung: '',
      abschlagBNK14: undefined,
      abschlagBNK59: undefined,
      abschlagJahr1: undefined,
      abschlagJahr2: undefined,
      abschlagJahr3: undefined,
      wip: undefined,
      gremium: undefined,
   }

   constructor(    
      public bezeichnungWIP: string,
      public gremiumBezeichnung : string,
      public plangebiet: number,
      public plangebietBezeichnung: string,
      public verwaltungsbereich: number,
      public verwaltungsbereichBezeichnung: string,
      public abschlagBNK14?: number,
      public abschlagBNK59?: number,
      public abschlagJahr1?: number,
      public abschlagJahr2?: number,
      public abschlagJahr3?: number,
      public wip?: number,
      public gremium?: number,
   ) {}
}
